<template>
  <div>
    <v-img class="white--text mb-6" :src="require('@/assets/Pinners_squarepromo.jpg')"> </v-img>

    <v-card-text v-if="!showCheckEmail" class="text--primary">
      <h2 class="text-center font-weight-light text--secondary">A world of offers. Sign up now!.</h2>

      <p class="text--secondary text-center caption mt-2">Sign up for our monthly deals below.</p>

      <EmailLoginForm
        :disabled="email_disabled"
        :onboard-source="onboardSource"
        @login-email-requested-started="handleLoginEmailRequestStarted"
        @login-request-complete="handleLoginRequestComplete"
      />

      <div class="text-center font-weight-light mt-3 mb-3">or</div>

      <FacebookLoginButton
        :disabled="facebook_disabled"
        :onboard-source="onboardSource"
        @login-facebook-requested-started="handleLoginFacebookRequestStarted"
        @login-request-complete="handleLoginRequestComplete"
        @login-request-failed="handleLoginRequestFailed"
      />
    </v-card-text>

    <v-card-text v-else class="text-center">
      <h2 class="font-weight-light text--secondary">Awesome!</h2>
      <p class="mt-4">Check your email for a link that will log you in!</p>
    </v-card-text>
  </div>
</template>

<script>
import Vue from 'vue'

import EmailLoginForm from '@/components/login/EmailLoginForm.vue'
import FacebookLoginButton from '@/components/login/FacebookLoginButton.vue'

export default Vue.extend({
  name: 'SignupForm',

  components: {
    EmailLoginForm,
    FacebookLoginButton,
  },
  props: {
    onboardSource: {
      type: String,
      default: 'Unknown',
    },
  },

  data: () => ({
    showCheckEmail: false,
    loading: false,
    email_disabled: false,
    facebook_disabled: false,
  }),

  methods: {
    handleLoginEmailRequestStarted: function () {
      this.facebook_disabled = true
    },
    handleLoginFacebookRequestStarted: function () {
      this.email_disabled = true
    },
    handleLoginRequestComplete: function () {
      this.email_disabled = false
      this.facebook_disabled = false
      this.showCheckEmail = true
    },
    handleLoginRequestFailed: function () {
      this.email_disabled = false
      this.facebook_disabled = false
      this.showCheckEmail = false
    },
  },
})
</script>
